var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0H0V40H8H32V32H8V0ZM32 0H16V8H32V0ZM24 16H16V24H24V16Z",
    fill: "#E9E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.77add12265349751e5e586e986088506.svg";
export { ForwardRef as ReactComponent };